<template>
  <span class="ds-chip" :class="`ds-chip--${tone}`"><span class="ds-chip__dot" aria-hidden="true" />{{ label }}</span>
</template>

<script setup lang="ts">
/** Status pill with a dot (03 §6). Tones come from the existing mappings (conciergeUi.stageTone, topupStatus). */
withDefaults(defineProps<{ label: string; tone?: 'pending' | 'done' | 'blocked' | 'neutral' }>(), { tone: 'pending' });
</script>

<style scoped lang="scss">
.ds-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.ds-chip__dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.ds-chip--pending { background: var(--soft); color: var(--bronze-text); }
.ds-chip--done { background: var(--success-bg); color: var(--success-text); }
.ds-chip--blocked { background: #F3E3DF; color: var(--red); }
.ds-chip--neutral { background: var(--sidebar); color: var(--muted); }
</style>
